import React from 'react';
import { COLOR } from '@src/styles/color';
import { IconButton } from '@mui/material';
import FiberManualRecordRoundedIcon from '@mui/icons-material/FiberManualRecordRounded';
import SortRoundedIcon from '@mui/icons-material/SortRounded';

const SortVoice = ({ setOpenSort, hasSort }) => (
  <div>
    <IconButton className="filter-btn" onClick={() => setOpenSort(true)}>
      <SortRoundedIcon sx={{ fontSize: '24px', color: COLOR.navyBlue }} />
      {hasSort && (
        <FiberManualRecordRoundedIcon
          className="circle-btn"
          sx={{ color: COLOR.textPending, fontSize: '16px !important' }}
        />
      )}
    </IconButton>
  </div>
);

export default SortVoice;
